// @flow

export const formatTitle = (text: string) => `${text} | MIT Open Learning`
